import React from "react";
import { UseAuthToken } from "../../../../../../../../libs/api/userSession";
import useSWRMutation from "swr/mutation";
import {
  parseClientError,
  swrMutationFetcher,
  SwrMutationFetcherArgType,
} from "../../../../../../../../libs/api/Endpoints";
import { SuccessDataType } from "../../../../../../../../libs/api/types";
import { generatetoast } from "../../../../../../../../global components/Toast";
import { SubmitHandler, useForm } from "react-hook-form";
import s from "./DeclineRequestForm.module.scss";
import clsx from "clsx";
import { Button } from "antd";
type InputType = {
  adminNotes: string;
};
type PropType = {
  id: string;
  mutate: () => void;
  closeModal: () => void;
};
function DeclineRequestForm({ id, mutate, closeModal }: PropType) {
  const token = UseAuthToken();
  const { trigger: declineRequest, isMutating } = useSWRMutation(
    `api/admin/phone-numbers/requests/${id}/decline`,
    swrMutationFetcher
  );
  const {
    formState: { errors },
    reset,
    handleSubmit,
    register,
  } = useForm<InputType>();
  const handleDeclination: SubmitHandler<InputType> = async (
    data: InputType
  ) => {
    try {
      const fetcheArg: SwrMutationFetcherArgType = {
        token,
        requestOption: {
          method: "PATCH",
          body: JSON.stringify({ adminNotes: data.adminNotes }),
          headers: {
            "Content-Type": "application/json",
          },
        },
      };

      const result: SuccessDataType<any> = await declineRequest(fetcheArg);
      generatetoast("success", result.message);
      mutate();
      reset();
      closeModal();
    } catch (error) {
      const e = parseClientError(error);
      generatetoast("error", e.message || "Something went wrong");
    }
  };
  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <h4 className={s.title}>Decline request</h4>
      </div>
      <form className={s.form} onClick={handleSubmit(handleDeclination)}>
        <div className={s.inputWrapper}>
          <h6 className={s.label}>Reason</h6>
          <textarea
            placeholder="Why decline this request?"
            {...register("adminNotes", { required: "Admin note is required" })}
            className={clsx(s.textArea, {
              [s.inputError]: errors.adminNotes?.message,
            })}
          />
          {errors.adminNotes?.message && (
            <p className={s.errorMessage}>{errors.adminNotes.message}</p>
          )}
        </div>
        <div className={s.btnGroups}>
          <button className={s.cancelBtn} type="button" onClick={closeModal}>
            Cancel
          </button>
          <Button
            className={s.submitBtn}
            htmlType="submit"
            loading={isMutating}
          >
            Decline request
          </Button>
        </div>
      </form>
    </div>
  );
}

export default DeclineRequestForm;
